import { z } from "zod";
import { Step1Schema } from "./step1";
import { Step2Schema } from "./step2";
import { Step3Schema } from "./step3";
import { Step4Schema } from "./step4";
import { Step5Schema } from "./step5";
import { Step6Schema } from "./step6";
import { RentersStep1Schema } from "./rentersStep1";
import { RentersStep2Schema } from "./rentersStep2";
import { RentersStep3Schema } from "./rentersStep3";
import { RentersStep4Schema } from "./rentersStep4";

export * from "./step1";
export * from "./step2";
export * from "./step3";
export * from "./step4";
export * from "./step5";
export * from "./step6";
export * from "./rentersStep1";
export * from "./rentersStep2";
export * from "./rentersStep3";
export * from "./rentersStep4";

export const FullSchemaBase = z.object({
  step1: Step1Schema,
  step2: Step2Schema,
  step3: Step3Schema,
  step4: Step4Schema,
  step5: Step5Schema,
  step6: Step6Schema,
});

export const FullSchema = FullSchemaBase;

export const FullSchemaRentersBase = z.object({
  step1: RentersStep1Schema,
  step2: RentersStep2Schema,
  step3: RentersStep3Schema,
  step4: RentersStep4Schema,
});

export const FullSchemaRenters = FullSchemaRentersBase;
